import React from "react";

import { useTranslation } from "react-i18next";

// import "../../css/admin/timeline.scss";
import videoPlaceholder from "../../resources/video_placeholder.jpg";
import { Card, CardDescription, CardHeader, CardTitle } from "../ui/card";

interface TimelineItemData {
  datetime: string;
  duration: number;
  label: string;
  media_picture: string;
  media_type: string;
  media_uuid: string;
  storefront_project_uuid: string;
  uuid: string;
}

interface TimelineItemProps {
  item: TimelineItemData;
  onClick: (item: TimelineItemData) => void;
  cardPicture: string;
  cardTitle: string;
  durationString: string;
  dateString: string;
  timeString: string;
}

function TimelineItem({
  item,
  onClick,
  cardPicture,
  cardTitle,
  durationString,
  dateString,
  timeString,
}: TimelineItemProps): React.JSX.Element {
  const { t } = useTranslation("editor-content");

  return (
    <div className="p-2.5">
      <Card
        className="relative mx-auto w-full max-w-sm cursor-pointer gap-4 rounded-lg pt-0 pb-4"
        onClick={() => onClick(item)}
      >
        <img
          alt="Event cover"
          className="relative aspect-video w-full rounded-t-lg object-cover"
          src={cardPicture || videoPlaceholder}
        />
        {durationString ? (
          <div
            className="bg-overlay text-overlay-foreground absolute top-2 right-2 rounded px-2 py-1 text-xs"
            title={t("duration")}
          >
            {durationString}
          </div>
        ) : null}
        <CardHeader className="px-4">
          <CardTitle className="overflow-hidden text-ellipsis whitespace-nowrap">
            {cardTitle}
          </CardTitle>
          <CardDescription>
            <div className="flex justify-between">
              <div className="text-xs">{dateString}</div>
              {timeString ? <div className="text-xs">{timeString}</div> : null}
            </div>
          </CardDescription>
        </CardHeader>
      </Card>
    </div>
  );
}

export default TimelineItem;
